import React, { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

import {
  Navigation,
  Autoplay,
} from "swiper/modules";

import {
  FaArrowRight,
} from "react-icons/fa";

import "../styles/ProductsSection.css";

const ProductsSection = () => {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FETCH PRODUCTS ================= */

  useEffect(() => {

    const fetchProducts = async () => {

      try {

        const res = await fetch(
          "https://backend.sacmtb.com/api/products"
        );

        if (!res.ok)
          throw new Error("Failed");

        const data = await res.json();

        let list = [];

        if (Array.isArray(data)) {
          list = data;
        } else if (
          Array.isArray(data.products)
        ) {
          list = data.products;
        }

        setProducts(list);

      } catch (err) {

        console.error(err);

        setProducts([]);

      } finally {

        setLoading(false);
      }
    };

    fetchProducts();

  }, []);

  /* ================= LOADING ================= */

  if (loading) {

    return (

      <section className="editorial-products">

        <div className="editorial-header">

          <p>
            FEATURED COLLECTION
          </p>

          <h2>
            Loading Products...
          </h2>

        </div>

      </section>
    );
  }

  /* ================= UI ================= */

  return (

    <section className="editorial-products">

      {/* HEADER */}

      <div className="editorial-header">

        <p>
          FEATURED COLLECTION
        </p>

        <h2>
          PREMIUM RIDES
        </h2>

      </div>

      {/* SLIDER */}

      <Swiper

        modules={[
          Navigation,
          Autoplay,
        ]}

        navigation={true}

        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}

        speed={900}

        loop={true}

        centeredSlides={false}

        watchOverflow={true}

        slidesPerView={3}

        spaceBetween={24}

        breakpoints={{

          0: {
            slidesPerView: 1.1,
            spaceBetween: 14,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },

          1200: {
            slidesPerView: 3,
            spaceBetween: 24,
          },

        }}

        className="editorial-swiper"
      >

        {products.map((product) => (

          <SwiperSlide
            key={product._id}
          >

            <div
              className="editorial-card"
              onClick={() =>
                window.location.href =
                `/productdetailpage/${product._id}`
              }
            >

              {/* IMAGE */}

              <div className="editorial-image-wrap">

                <img
                  src={
                    product.imageUrls?.[0] ||
                    "https://via.placeholder.com/500"
                  }
                  alt={product.name}
                  className="editorial-image"
                />

              </div>

              {/* CONTENT */}

              <div className="editorial-content">

                <h3>

                  {product.name.length > 28
                    ? product.name.substring(
                        0,
                        28
                      ) + "..."
                    : product.name}

                </h3>

                <span className="editorial-subtitle">

                  {product.category ||
                    "Premium Ride"}

                </span>

                <div className="editorial-bottom">

                <div className="editorial-price">
  {product.discountPrice ? (
    <>
      <span className="original-price"> Price
        ₹{product.price.toLocaleString()}
      </span>
  <br/>      
      <span className="discount-price"> Discount Price
        ₹{product.discountPrice.toLocaleString()}
      </span>

      

      <span className="discount-badge">
        {Math.round(
          ((product.price - product.discountPrice) /
            product.price) *
            100
        )}
        % OFF
      </span>
    </>
  ) : (
    <span className="discount-price">
      ₹{product.price.toLocaleString()}
    </span>
  )}
</div>

                  <button className="editorial-btn">

                    Explore

                    <FaArrowRight />

                  </button>

                </div>

              </div>

            </div>

          </SwiperSlide>

        ))}

      </Swiper>

    </section>
  );
};

export default ProductsSection;